import React from 'react';
import { ProjectRow } from '../../lib/types';

interface PipelineColumn {
  id: string;
  title: string;
  description: string;
  statuses: ProjectRow['Status'][];
}

const GOVERNANCE_COLUMNS: PipelineColumn[] = [
  {
    id: 'ready-for-governance',
    title: 'Gate 1: Ready for Governance',
    description: 'Assessment complete, awaiting governance decision',
    statuses: ['ReadyForGovernance'],
  },
  {
    id: 'below-the-line',
    title: 'Below-the-Line (Fast Path)',
    description: 'Approved for fast track (Effort < 3 days, High Impact)',
    statuses: ['BelowTheLine'],
  },
  {
    id: 'above-the-line',
    title: 'Gate 2a: Approved for Business Case',
    description: 'Portfolio approved to invest in business case & planning',
    statuses: ['AboveTheLine'],
  },
  {
    id: 'validation',
    title: 'In Validation & Planning',
    description: 'Building business case and planning implementation',
    statuses: ['InValidation', 'InPlanning'],
  },
  {
    id: 'ready-for-delivery',
    title: 'Gate 2b: Ready for Delivery',
    description: 'Portfolio approved to proceed with delivery',
    statuses: ['ReadyForDelivery'],
  },
  {
    id: 'in-delivery',
    title: 'In Delivery',
    description: 'Currently being executed',
    statuses: ['InDelivery'],
  },
  {
    id: 'complete',
    title: 'Complete',
    description: 'Finished and delivered',
    statuses: ['Complete'],
  },
];

export interface GovernanceBoardProps {
  projects: ProjectRow[];
  onSelectProject: (id: string | null) => void;
}

export function GovernanceBoard({ projects, onSelectProject }: GovernanceBoardProps) {
  const getProjectsForColumn = (statuses: ProjectRow['Status'][]): ProjectRow[] => {
    return projects.filter(p => statuses.includes(p.Status));
  };

  return (
    <div className="governance-board">
      {GOVERNANCE_COLUMNS.map(column => (
        <div key={column.id} className="governance-column">
          <div className="column-header">
            <h3>{column.title}</h3>
            <span className="column-count">
              {getProjectsForColumn(column.statuses).length}
            </span>
          </div>
          <p className="column-description">{column.description}</p>
          <div className="column-cards">
            {getProjectsForColumn(column.statuses).map(project => (
              <div
                key={project.ProjectId}
                className={`project-card ${project.RiskComplianceSecurityFlag ? 'flagged' : ''}`}
                onClick={() => onSelectProject(project.ProjectId)}
                role="button"
                tabIndex={0}
              >
                <div className="card-header">
                  <span className="card-id">{project.ProjectId}</span>
                  {project.Priority && <span className="card-priority">{project.Priority}</span>}
                </div>
                <h4 className="card-title">{project.Title}</h4>
                <div className="card-meta">
                  <span className="card-domain">{project.Domain}</span>
                  <span className="card-type">{project.WorkType}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
